@if (state.isPulling) {
  <div class="pull-to-refresh-indicator" [class]="'pull-to-refresh-indicator pull-progress-' + pullProgressBucket">
    <span class="pull-to-refresh-icon">
      <mat-icon> refresh</mat-icon>
    </span>
  </div>
}
